<template>
  <div class="opera-homePageOpera">
    <div class="hdfix"
         :class="{hd2:topMsg.v}">
      <div class="header">
        <span @click='goSearch'>{{homeUserInfo.hotelName}} <i class="iconfont icon-xia"></i></span>
        <div class="right"
             @click="getbarcode"><i class="iconfont icon-saoma"></i></div>
        <div class="topMsg"
             v-if="topMsg.v">
          <a v-if="topMsg.url && topMsg.url.indexOf('http') == 0"
             @click="openUrl(topMsg.url)">{{topMsg.msg | flength}}</a>
          <router-link :to="topMsg.url"
                       v-else-if="topMsg.url">{{topMsg.msg | flength}}>></router-link>
          <template v-else>{{topMsg.msg | flength}}</template>
          <div class="cleartext"
               @click="closeTopMsg">
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>
      </div>
    </div>

    <mt-loadmore :top-method="loadTop" @top-status-change="handleTopChange" :top-status.sync="topStatus" ref="loadmore">
      <div class="myList">
        <my-list></my-list>
      </div>
      <template v-if="!isHideDashboard">
      <homeData ref="homeData"></homeData>
      <div slot="top" class="mint-loadmore-top">
        <span v-show="topStatus !== 'loading'" :class="{ 'rotate': topStatus === 'drop' }"> ↓ {{ $t('index_refresh') }}</span>
        <span v-show="topStatus === 'loading'">Loading...</span>
      </div>
      </template>
    </mt-loadmore>
    <foot-nav sta='1'></foot-nav>
  </div>
</template>
<script>
  import myList from "../operaCommon/myList";
  import footNav from "../operaCommon/footNav";
  import homeData from "../operaCommon/homeData";
  import {Toast, MessageBox} from "mint-ui";

  export default {
    data() {
      return {
        topStatus: "",
        homeUserInfo: {},
        topMsg: {v: false, msg: "", type: "msg", link: ""},
        isHideDashboard: localStorage.getItem('isHideDashboard') == 'yes'
      };
    },
    mounted() {
      this.getHomeUserInfo();
      var that = this;
      window.showTopMsg = this.showTopMsg;
      window.setTimeout(function () {
        that.versionMsg();
      }, 2000);
      //使跳回首页页面显示在顶部，而不是中间段
      document.getElementsByClassName("opera-homePageOpera")[0].scrollTop = 0;
    },
    methods: {
      getHomeUserInfo() {
        this.$http.get("/mobilepmsapi/sys/getHomeUserInfo").then(res => {
          if (res.data.result == 0) {
            this.homeUserInfo = res.data.retVal;
            this.disHomeData();
          }
        });
      },
      disHomeData() {
        if (this.homeUserInfo.bHomeData && this.$refs.homeData) {
          this.$refs.homeData.getData();
        }
      },
      versionMsg() {
        if (this.$isApp) {
          this.waitReady();
        } else {
          if (
            localStorage.getItem("version") == null ||
            localStorage.getItem("version") != this.pversion
          ) {
            localStorage.setItem("version", this.pversion);
            this.showTopMsg(
              this.pversion +this.$t('index_new_version'),
              "msg",
              "/versionDetail?redirect=/opera/"
            );
          }
        }
      },
      plusReady() {
        var c = plus.storage;
        if (
          c.getItem("version") == null ||
          c.getItem("version") != this.pversion
        ) {
          c.setItem("version", this.pversion);
          this.showTopMsg(
            this.pversion + this.$t('index_new_version'),
            "msg",
            "/versionDetail?redirect=/opera/"
          );
        } else {
          var A = plus.webview.getLaunchWebview();
          A.evalJS("disPushMsg()");
        }
      },
      waitReady() {
        if (window.plus) {
          this.plusReady();
        } else {
          document.addEventListener("plusReady", this.plusReady, false);
        }
      },
      showTopMsg(msg, type, url) {
        this.topMsg = {
          msg: msg,
          v: true,
          type: type,
          url: url && url.indexOf("#") == 0 ? url.substr(1) : url
        };
      },
      closeTopMsg() {
        this.topMsg.v = false;
        if (this.topMsg.type == "push") {
          var A = plus.webview.getLaunchWebview();
          A.evalJS("clearPushMsg()");
        } else {
          if (this.$isApp) {
            var A = plus.webview.getLaunchWebview();
            A.evalJS("disPushMsg()");
          }
        }
      },
      msg(msg) {
        Toast({message: msg, position: "bottom", duration: 3000});
      },
      getbarcode() {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.barback = function (a) {
          that.$http
            .post("/mobilepmsapi/sys/getScanResult", {data: a})
            .then(res => {
              if (res.data.result == 0) {
                var d = res.data.retVal;
                console.log(d.data);
                if (d.type == "login") {
                  A.evalJS('openUrl("' + d.data + '")');
                } else if (d.type == "url") {
                  A.evalJS('openUrl("' + d.data + '")');
                } else if (d.type == "coupon") {
                  that.$router.push("/opera/CouponUse?couponNo=" + d.data);
                } else {
                  MessageBox.confirm(d.data, "", {
                    confirmButtonText: that.$t("Copy")
                  }).then(action => {
                    A.evalJS('copy("' + d.data + '")');
                    that.msg2( that.$t("CopySuccess"));
                  });
                }
              } else {
                that.msg(res.data.msg);
              }
            });
        };
        A.evalJS("getcardCode()");
      },
      goSearch() {
        this.$router.push("/search");
      },
      handleTopChange: function (status) {
        this.topStatus = status;
      },
      loadTop() {
        this.disHomeData();
        this.$refs.loadmore.onTopLoaded();
      },
    },
    filters: {
      flength(value) {
        return value.length > 30 ? value.substr(0, 28) + ".. " : value;
      }
    },
    components: {
      myList,
      footNav,
      homeData
    }
  };
</script>
<style lang='less' scoped>
  .opera-homePageOpera {
    overflow: auto;

    .hdfix {
      height: 1.066667rem;

      .header {
        height: 1.066667rem;
        background-color: #393c41;
        position: fixed;
        width: 100%;
        z-index: 2;

        .right {
          position: absolute;
          right: 0.3rem;
          top: 0;
          color: #fff;

          i {
            font-size: 0.6rem;
            line-height: 1.066667rem;
          }

          /* div{font-size:0.32rem;transform:scale(0.6);position: absolute;top:0.6rem;left:0.14rem}*/
        }

        span {
          font-size: 0.4rem;
          width: 75%;
          display: block;
          margin: 0 auto;
          text-align: center;
          color: #fff;
          line-height: 1.066667rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .hd2 {
      height: 1.94rem;
    }

    .topMsg {
      color: #6c6500;
      height: 0.9rem;
      width: 100%;
      background: #f6ef8b;
      line-height: 0.9rem;
      padding-left: 0.3rem;
      margin-top: -2px;

      a {
        color: #6c6500;
      }

      .cleartext {
        float: right;
        padding-right: 0.3rem;
        margin-top: -0.01rem;

        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #cabc00;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// index.vue?f6c4fa94